/*
 * Stage-by-stage funnel — each row is a track + percentage meta.
 *
 * The first stage's count is the denominator; subsequent stages render
 * their count as a percentage of the first.
 */

import type { FunnelStage } from '../aggregate';

interface FunnelProps {
  stages: FunnelStage[];
}

export function Funnel({ stages }: FunnelProps) {
  if (stages.length === 0) return null;
  return (
    <div role="list">
      {stages.map((s) => (
        <div className="funnel-row" key={s.label} role="listitem">
          <div className="funnel-row__track">
            <div
              className="funnel-row__fill"
              style={{ width: `${Math.max(s.pct, 6)}%` }}
              aria-hidden
            >
              {s.label}
            </div>
          </div>
          <div className="funnel-row__meta">
            <strong>{s.count}</strong> · {s.pct}%
          </div>
        </div>
      ))}
    </div>
  );
}
